module.exports = __webpack_public_path__ + "static/media/fly0103.8fb9765b.webp";